module.exports = __webpack_public_path__ + "static/img/weixin.8b3af3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/weixin.png
// module id = rirt
// module chunks = 1